import numeral from 'numeral'

export default function numeric(value, format = '0,0') {
  return numeral(value).format(format)
}
